"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouteGenerationOutcome = void 0;
const typeorm_1 = require("typeorm");
const uuid_1 = require("uuid");
/**
 * used to memoize outcomes in `RouteGenerationService`
 * @deprecated
 */
let RouteGenerationOutcome = class RouteGenerationOutcome {
    _id = (0, uuid_1.v4)();
    locationIdPair;
    generated;
    routeId = null;
};
exports.RouteGenerationOutcome = RouteGenerationOutcome;
__decorate([
    (0, typeorm_1.ObjectIdColumn)(),
    __metadata("design:type", String)
], RouteGenerationOutcome.prototype, "_id", void 0);
__decorate([
    (0, typeorm_1.ObjectIdColumn)(),
    __metadata("design:type", Array)
], RouteGenerationOutcome.prototype, "locationIdPair", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Boolean)
], RouteGenerationOutcome.prototype, "generated", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    __metadata("design:type", Object)
], RouteGenerationOutcome.prototype, "routeId", void 0);
exports.RouteGenerationOutcome = RouteGenerationOutcome = __decorate([
    (0, typeorm_1.Entity)("routeGenerationOutcome")
], RouteGenerationOutcome);
//# sourceMappingURL=RouteGenerationOutcome.js.map